import { Badge, createTheme } from "@mantine/core";

/** Armenian-first typography: Noto Sans Armenian covers Armenian, Latin and Cyrillic glyphs. */
export const theme = createTheme({
  fontFamily: '"Noto Sans Armenian", "Segoe UI", Arial, sans-serif',
  headings: {
    fontFamily: '"Noto Sans Armenian", "Segoe UI", Arial, sans-serif',
    fontWeight: "600",
  },
  primaryColor: "indigo",
  // Armenian in all caps is hard to read: keep badge text as written.
  components: { Badge: Badge.extend({ defaultProps: { tt: "none" } }) },
  defaultRadius: "md",
});
